(() => {
  if (customElements.get('ava-exercise-previews')) return;
  customElements.define('ava-exercise-previews', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      const on = (element, name, handler) => element.addEventListener(name, handler, {signal:this.abort.signal});
      this.cards = [...this.querySelectorAll('[data-preview-card]')];
      this.dialog = this.querySelector('dialog');
      this.video = this.querySelector('video');
      this.toggle = this.querySelector('[data-preview-toggle]');
      this.seek = this.querySelector('input[type="range"]');
      this.status = this.querySelector('[data-preview-status]');
      this.index = 0;
      this.cards.forEach((card, index) => on(card, 'click', () => this.open(index, card)));
      on(this.querySelector('[data-preview-close]'), 'click', () => this.dialog.close());
      on(this.dialog, 'click', event => {if(event.target === this.dialog){const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.dialog.close();}});
      on(this.dialog, 'close', () => this.cleanup());
      on(this.querySelector('[data-preview-previous]'), 'click', () => this.select(this.index - 1));
      on(this.querySelector('[data-preview-next]'), 'click', () => this.select(this.index + 1));
      on(this.toggle, 'click', () => {if(this.video.paused){if(this.video.ended)this.video.currentTime=0;this.play();}else this.video.pause();});
      on(this.video, 'play', () => {this.toggle.textContent='Pause';this.toggle.setAttribute('aria-label','Sæt øvelsen på pause');this.status.textContent='';});
      on(this.video, 'pause', () => this.setPausedLabel());
      on(this.video, 'ended', () => this.setPausedLabel());
      on(this.video, 'error', () => {if(this.video.getAttribute('src'))this.status.textContent='Videoen kunne ikke indlæses. Prøv at vælge øvelsen igen.';});
      on(this.video, 'timeupdate', () => this.progress());
      on(this.video, 'loadedmetadata', () => this.progress());
      on(this.seek, 'input', () => {if(Number.isFinite(this.video.duration))this.video.currentTime=Number(this.seek.value)/100*this.video.duration;});
      on(this.querySelector('[data-preview-fullscreen]'), 'click', async () => {
        if(this.dialog.classList.contains('is-expanded')){this.dialog.classList.remove('is-expanded');return;}
        const expand=()=>this.dialog.classList.add('is-expanded');
        try {if(document.fullscreenElement)await document.exitFullscreen();else if(this.querySelector('[data-preview-player]').requestFullscreen)await this.querySelector('[data-preview-player]').requestFullscreen();else if(this.video.webkitEnterFullscreen)this.video.webkitEnterFullscreen();else expand();}catch{expand();}
      });
      on(document, 'variant:change', event => {if(String(event.detail?.variant?.id)!==this.dataset.variantId){if(this.dialog.open)this.dialog.close();}});
    }
    disconnectedCallback() {if(this.dialog?.open)this.dialog.close();this.cleanup();this.abort?.abort();this.ready=false;}
    open(index, opener) {
      this.opener=opener;
      if(!this.dialog.open){this.previousOverflow=document.body.style.overflow;this.dialog.showModal();document.body.style.overflow='hidden';}
      this.select(index);
    }
    select(index) {
      if(index<0||index>=this.cards.length)return;
      this.index=index;
      const card=this.cards[index];
      this.video.pause();
      this.querySelector('[data-preview-title]').textContent=card.dataset.name;
      this.querySelector('[data-preview-counter]').textContent=`${this.dataset.variantTitle || 'Morgenmobilitet'} · Øvelse ${index+1} af ${this.cards.length}`;
      this.video.setAttribute('aria-label',card.dataset.name+' – én komplet gentagelse');
      this.video.poster=card.dataset.poster;
      this.video.src=card.dataset.src;
      this.video.muted=true;
      this.video.playbackRate=1;
      this.seek.value='0';
      this.querySelector('[data-preview-time]').textContent='0:00';
      this.querySelector('[data-preview-previous]').disabled=index===0;
      this.querySelector('[data-preview-next]').disabled=index===this.cards.length-1;
      this.status.textContent='Indlæser øvelsen…';
      this.video.load();
      this.play();
    }
    play() {this.video.play().catch(error=>{if(error.name!=='AbortError'&&this.dialog.open){this.setPausedLabel();this.status.textContent='Tryk på Afspil for at se øvelsen.';}});}
    setPausedLabel() {this.toggle.textContent=this.video.ended?'Se igen':'Afspil';this.toggle.setAttribute('aria-label',this.video.ended?'Afspil øvelsen igen':'Afspil øvelsen');}
    progress() {
      const duration=this.video.duration;
      if(!Number.isFinite(duration)||duration<=0)return;
      const format=s=>`${Math.floor(s/60)}:${String(Math.floor(s%60)).padStart(2,'0')}`;
      this.seek.value=String(this.video.currentTime/duration*100);
      this.seek.setAttribute('aria-valuetext',`${format(this.video.currentTime)} af ${format(duration)}`);
      this.querySelector('[data-preview-time]').textContent=`${format(this.video.currentTime)} / ${format(duration)}`;
    }
    cleanup() {
      if(!this.video)return;
      this.video.pause();this.video.removeAttribute('src');this.video.load();this.dialog.classList.remove('is-expanded');
      if(this.previousOverflow!==undefined){document.body.style.overflow=this.previousOverflow;this.previousOverflow=undefined;}
      if(this.opener?.isConnected&&this.opener.getClientRects().length)this.opener.focus({preventScroll:true});
    }
  });
})();
